import React from "react";
import { FaInstagram, FaFacebookF, FaWhatsapp } from "react-icons/fa";

export default function App() {
  return (
    <div style={{ backgroundColor: "#f9f6f2", minHeight: "100vh", color: "#8b0000", fontFamily: "sans-serif" }}>
      <header style={{ textAlign: "center", padding: "2rem" }}>
        <img src="/Logo.png" alt="Lustro Elite Auto Spa" style={{ width: "150px", marginBottom: "1rem" }} />
        <h1 style={{ fontSize: "2.5rem", fontWeight: "bold" }}>LUSTRO ELITE</h1>
        <p style={{ fontSize: "1.2rem", letterSpacing: "0.1em" }}>AUTO SPA</p>
      </header>

      <section style={{ padding: "2rem" }}>
        <h2 style={{ fontSize: "2rem", textAlign: "center", marginBottom: "1.5rem" }}>Nuestros Servicios</h2>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem", justifyContent: "center" }}>
          {[
            "Lavado Premium",
            "Encerado",
            "Limpieza de interiores",
            "Restauración de faros",
            "Lavado de motor",
            "Desinfección a vapor"
          ].map((servicio, i) => (
            <div key={i} style={{ background: "white", padding: "1rem", borderRadius: "8px", boxShadow: "0 2px 5px rgba(0,0,0,0.1)", minWidth: "200px", textAlign: "center" }}>
              {servicio}
            </div>
          ))}
        </div>
      </section>

      <section style={{ textAlign: "center", padding: "2rem" }}>
        <h2 style={{ fontSize: "2rem", marginBottom: "1rem" }}>Contáctanos</h2>
        <a href="https://wa.me/16025361975" target="_blank" rel="noopener noreferrer" style={{ display: "inline-block", backgroundColor: "#8b0000", color: "white", padding: "0.8rem 2rem", borderRadius: "6px", textDecoration: "none", marginBottom: "1rem" }}>
          <FaWhatsapp style={{ marginRight: "0.5rem" }} /> WhatsApp
        </a>
        <div style={{ fontSize: "1.5rem", marginTop: "1rem" }}>
          <a href="https://www.instagram.com/lustro_elite_auto_spa?igsh=a24xZTNxNzRyaXo3" target="_blank" rel="noopener noreferrer" style={{ margin: "0 1rem", color: "#8b0000" }}><FaInstagram /></a>
          <a href="https://www.facebook.com/share/1YLM1eME2X/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" style={{ margin: "0 1rem", color: "#8b0000" }}><FaFacebookF /></a>
        </div>
      </section>

      <footer style={{ textAlign: "center", fontSize: "0.9rem", padding: "2rem" }}>
        © {new Date().getFullYear()} Lustro Elite Auto Spa. Todos los derechos reservados.
      </footer>
    </div>
  );
}
